import PropTypes from 'prop-types';
import React from 'react';
import browserIsIE from './utilities/browserIsIE.js';

const Panel = ({
  children,
  style,
}) => {

  let componentStyle = {
    height: '285px',
    width: '314px',
    margin: '40px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    ...style,
  };

  if (browserIsIE()) {
    componentStyle.minWidth = '281px';
    componentStyle.maxWidth = '281px';
  }

  return (
    <div
      style={componentStyle}
    >
      {children}
    </div>
  );
};

Panel.propTypes = {
  children: PropTypes.node,
  style: PropTypes.object,
};

export default Panel;
